<template>
  <div class="vd-gl-content">
    12312
  </div>
</template>

<script>
export default {
  name: 'Robot',
}
</script>

<style scoped></style>
